import { render } from "./PayPal.vue?vue&type=template&id=470eeb83"
import script from "./PayPal.vue?vue&type=script&setup=true&lang=js"
export * from "./PayPal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PayPal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "470eeb83"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('470eeb83', __exports__)) {
    api.reload('470eeb83', __exports__)
  }
  
  module.hot.accept("./PayPal.vue?vue&type=template&id=470eeb83", () => {
    api.rerender('470eeb83', render)
  })

}


export default __exports__